import request from '@/assets/js/utils/request'
import getUrl from '@/assets/js/utils/get-url'

// 初始化试算因子
export function calculatePremium(data) {
  return request({
    url: getUrl(`/sale/product/getDetail`, 1), //根据来源 判断 调用计划书接口/电投接口
    method: 'post',
    data
  })
}
// 主险列表
export function mainRiskList(data) {
  return request({
    url: getUrl(`/${localStorage.isFrom}/product/getProductList`, 1),
    method: 'post',
    data
  })
}
// 微信分享获取主险列表
export function mainRiskListWX(data) {
  return request({
    url: getUrl(`/proposal/product/getProductList`, 1),
    method: 'post',
    data
  })
}

//试算
export function trial(data) {
  return request({
    url: getUrl(`/${localStorage.isFrom}/insure/trial`, 1),
    method: 'post',
    data
  })
}

//试算
export function mytrial(data) {
  return request({
    url: getUrl(`/engine/trial/trial`, 1, 4),
    method: 'post',
    data
  })
}

//订单详情
export function orderDetail(data) {
  return request({
    url: getUrl('/sale/order/orderDetail', 1),
    method: 'post',
    data
  })
}

//删除已选产品
export function deleteOrderInfo(data) {
  return request({
    url: getUrl('/sale/order/deleteOrderInfo', 1),
    method: 'post',
    data
  })
}
//获取微信分享
export function wxShare(data) {
  return request({
    url: getUrl('/ppf/wx/config', 1),
    method: 'post',
    data
  })
}
